import { cloudChiprApi } from "../../../../services/cloudchipr.api";
import { RootState } from "@/store/store";
import { resourceDetailsResourceCoverageDataPayloadSelector } from "@/store/resource-details/selectors/coverage-data/resourceDetailsResourceCoverageDataPayloadSelector";
import { postUsersMeOrganisationsCurrentCoverageFixedCacheKey } from "@/store/resource-details/thunks/coverage-data/getResourceDetailsResourceCoverageDataThunk";

export const resourceDetailsResourceCoverageDataRequestSelector = (
  state: RootState,
) => {
  const payload = resourceDetailsResourceCoverageDataPayloadSelector(state);

  if (!payload) {
    return;
  }

  return cloudChiprApi.endpoints.postUsersMeOrganisationsCurrentCoverage.select(
    postUsersMeOrganisationsCurrentCoverageFixedCacheKey,
  )(state);
};
